/* eslint-disable linebreak-style */
import React, { ReactElement } from 'react';
import { Form } from 'react-bootstrap';
import { getIn, FormikProps } from 'formik';

// import Creatable from 'react-select/creatable';
type RadioDefinitionType = {
  display: string // what gets shown to the user
  value: any,
}

type RadioButtonInput = {
  showLabel?: boolean,
  formikProps: FormikProps<any>
  fieldName: string,
  visibleName: string,
  extraClassValues?: string,
  formText?: string,
  possibleValues: Array<RadioDefinitionType>,
  onChangeCallback?: // the value of the checkbox that was selected.
  (val: any) => void,
}

const RadioButtonGroup: React.FC<RadioButtonInput> = (
  props: RadioButtonInput,
): ReactElement => {
  const {
    showLabel = true,
    fieldName,
    visibleName,
    extraClassValues = '',
    onChangeCallback = (foo) => { },
    formText = '',
    formikProps,
    possibleValues,
  } = props;

  const {
    values,
    errors,
    handleChange,
  } = formikProps;

  const checkboxRender: Array<ReactElement> = possibleValues.map((option) => {
    const currentFieldValue = getIn(values, fieldName);
    const isChecked = (currentFieldValue === option.value);
    return (
      <Form.Check
        key={`${fieldName}-${option.value}`}
        type="radio"
        name={fieldName}
        label={option.display}
        aria-label={visibleName}
        checked={isChecked}
        onChange={(e) => {
          handleChange({ target: { name: fieldName, value: option.value } });
          onChangeCallback(option.value);
        }}
      />
    );
  });

  const labelElement = showLabel && <Form.Label>{visibleName}</Form.Label>;

  return (
    <Form.Group controlId={fieldName} className={extraClassValues}>
      {labelElement}
      {checkboxRender}
      <Form.Text className="text-muted">
        {formText}
      </Form.Text>
      <Form.Control.Feedback type="invalid">
        {getIn(errors, fieldName)}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default RadioButtonGroup;
